import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useTranslation } from 'react-i18next';

// Tema (solo LECTURA del objeto de tema — no se toca src/styles/theme/**)
import { roisLightTheme } from '../../../styles/theme';

// Componentes
import { Loader } from '../../inputs/Loader';

// Styled components
import { SplashScreenContainer, SplashScreenText } from './styles';

/**
 * Pantalla de arranque a pantalla completa. Sustituye el blanco puro que ve
 * el usuario en arranque frío mientras: redux-persist rehidrata el store
 * (PersistGate.loading), Apollo restaura su caché persistida
 * (AppApolloProvider) o el router aún no resolvió sus loaders iniciales
 * (RouterProvider.fallbackElement).
 *
 * Se renderiza en dos contextos distintos: DENTRO de <ThemeProvider> (Apollo,
 * router) y FUERA de él (PersistGate.loading — en App.tsx el PersistGate
 * envuelve al ThemeProvider, así que ahí `theme` llega undefined a los
 * styled-components). Por eso:
 * - Los estilos propios (`styles.ts`) usan colores neutros fijos, no `theme`.
 * - El `Loader` canónico SÍ depende de `theme.colors.garnet*` sin fallback
 *   (`src/components/inputs/Loader/styles.ts`), así que se envuelve aquí en
 *   su propio `ThemeProvider` con el tema ROIS por defecto para garantizar
 *   que siempre tenga un theme válido, sin duplicar el spinner ni tocar el
 *   theme real de la app.
 */
export const SplashScreen = () => {
  const { t, ready } = useTranslation('common', { useSuspense: false });

  return (
    <SplashScreenContainer>
      <ThemeProvider theme={roisLightTheme}>
        <Loader />
      </ThemeProvider>
      {ready && (
        <SplashScreenText>{t('common:messages.loading')}</SplashScreenText>
      )}
    </SplashScreenContainer>
  );
};

export default SplashScreen;
